import React from 'react';
import { ShoppingCart, Wrench, Tag, CheckCircle2, Check } from 'lucide-react';

export const STATUS_STEPS = [
  { key: 'PURCHASED', label: 'Comprado', icon: ShoppingCart },
  { key: 'IN_PREPARATION', label: 'Em preparação', icon: Wrench },
  { key: 'AVAILABLE', label: 'Disponível', icon: Tag },
  { key: 'SOLD', label: 'Vendido', icon: CheckCircle2 },
];

export default function StatusStepper({ current, onChange, onSell, onUndoSale, disabled = false }) {
  const currentIdx = STATUS_STEPS.findIndex((s) => s.key === current);

  const handleClick = (step, idx) => {
    if (disabled) return;
    if (step.key === current) return;
    // If currently SOLD and moving to any other status: trigger undo flow
    if (current === 'SOLD' && step.key !== 'SOLD') {
      if (onUndoSale) {
        onUndoSale(step.key);
        return;
      }
    }
    // SOLD requires registering sale (price, document, buyer)
    if (step.key === 'SOLD') {
      if (onSell) onSell();
      return;
    }
    onChange(step.key);
  };

  return (
    <div className="bg-card border border-border/70 rounded-xl p-2 md:p-4" data-testid="status-stepper">
      <div className="flex items-center justify-between gap-1 md:gap-3 overflow-x-auto">
        {STATUS_STEPS.map((step, idx) => {
          const Icon = step.icon;
          const isDone = idx < currentIdx;
          const isCurrent = idx === currentIdx;
          const isFuture = idx > currentIdx;

          return (
            <React.Fragment key={step.key}>
              <button
                type="button"
                onClick={() => handleClick(step, idx)}
                disabled={disabled || isCurrent}
                title={isCurrent ? 'Status atual' : `Mudar para "${step.label}"`}
                data-testid={`status-step-${step.key}`}
                className={`group flex flex-col items-center gap-1 md:gap-1.5 px-1 md:px-2 py-1 rounded-lg transition-all min-w-[56px] md:min-w-[80px] flex-shrink-0
                  ${isCurrent ? 'cursor-default' : 'cursor-pointer hover:bg-muted/50'}
                  ${disabled ? 'opacity-60 pointer-events-none' : ''}
                `}
              >
                <div
                  className={`relative h-8 w-8 md:h-10 md:w-10 rounded-full grid place-items-center transition-all
                    ${isDone ? 'bg-[hsl(var(--success))] text-white' : ''}
                    ${isCurrent ? 'bg-[hsl(var(--primary))] text-white ring-2 md:ring-4 ring-[hsl(var(--primary))]/15 shadow-sm' : ''}
                    ${isFuture ? 'bg-muted text-muted-foreground group-hover:bg-muted/80' : ''}
                  `}
                >
                  {isDone ? <Check className="h-4 w-4 md:h-5 md:w-5" /> : <Icon className="h-4 w-4 md:h-5 md:w-5" />}
                </div>
                <div
                  className={`text-[10px] md:text-[11px] font-medium text-center leading-tight whitespace-nowrap
                    ${isCurrent ? 'text-foreground font-semibold' : ''}
                    ${isDone ? 'text-[hsl(var(--success))]' : ''}
                    ${isFuture ? 'text-muted-foreground' : ''}
                  `}
                >
                  {step.label}
                </div>
              </button>

              {idx < STATUS_STEPS.length - 1 && (
                <div
                  className={`flex-1 h-0.5 min-w-[8px] md:min-w-[12px] rounded-full transition-colors -mt-5 md:-mt-6
                    ${idx < currentIdx ? 'bg-[hsl(var(--success))]' : 'bg-border'}
                  `}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
